import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import { Spinner } from './ui/spinner';

type PageOverviewLoadingStateProps = React.ComponentProps<'div'> & {
  label?: string;
};

export const PageOverviewLoadingState = ({
  label,
  className,
  ...props
}: PageOverviewLoadingStateProps) => {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t('modules.mavue2.common.loading');

  return (
    <div
      role="status"
      aria-label={resolvedLabel}
      aria-live="polite"
      className={cn(
        'flex min-h-[calc(100dvh-12rem)] w-full items-center justify-center text-muted-foreground',
        className
      )}
      {...props}
    >
      <Spinner className="size-8" role="presentation" aria-hidden="true" />
    </div>
  );
};
